import React, { HTMLAttributes, useEffect, useState } from "react";

import BaseTabs from "../../atom/baseTabs";
import UserInfoManageBlock from "../userInfoManageBlock";

interface IUserInfoBlock {}

type TUserInfoBlockProps = IUserInfoBlock & HTMLAttributes<HTMLDivElement>;

const UserInfoBlock: React.FC<TUserInfoBlockProps> = (props) => {
  const { ...otherProps } = props;
  const [currentPhone, setCurrentPhone] = useState<string>("");
  const usertabs = [
    // {
    //   label: "車牌＆信用卡資料",
    //   key: "carplateInfo",
    //   content: <UserCarplateManageBlock />,
    // },
    {
      label: "個人資料",
      key: "accountInfo",
      content: (
        <div className="min-h-80 text-3xl text-white font-bold text-center">
          <UserInfoManageBlock />
        </div>
      ),
    },
  ];

  useEffect(() => {
    const loginState = JSON.parse(localStorage.getItem("wbloginState") || "{}");
    setCurrentPhone(loginState.phone);
  }, []);

  return (
    <div className="flex flex-1 flex-col gap-8" {...otherProps}>
      <div className="flex flex-row justify-between items-center text-sm font-bold">
        <div className="text-mainYellow">
          歡迎來到 AI Parkingbees, {currentPhone}
        </div>
      </div>
      <BaseTabs tabs={usertabs} className="rounded-none bg-transparent" />
    </div>
  );
};

export default UserInfoBlock;
